import { doLogout } from 'actions/authAction'
import {
  BASE_URL
} from 'actions/constant'

export const JENIS_CONSIGNEE_BERANGKAT_URL = "list_jenis_consignee_berangkat"
export const JENIS_CONSIGNEE_BERANGKAT_GET_SUCCESS = "JENIS_CONSIGNEE_BERANGKAT_GET_SUCCESS"

const jenisConsigneeBerangkatGetSuccess = (bool, consigneeBerangkat, msg) => {
    return {
      type: JENIS_CONSIGNEE_BERANGKAT_GET_SUCCESS,
      load: bool,
      val: consigneeBerangkat.data,
      msg:msg
    }
  }

export function jenisConsigneeBerangkatFetchAll(params) {
  return (dispatch) => {
    dispatch(jenisConsigneeBerangkatGetSuccess(true, { data: [] }))
    let token = localStorage.getItem('tolaut@token') || null
    let config = {}
    if (token) {
      config = {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
      if (params) {
        config.body = JSON.stringify(params)
      }
    } else {
      throw Error("Authentication error")
    }
    fetch(BASE_URL + JENIS_CONSIGNEE_BERANGKAT_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout())
        }
        if (!response.ok) {
          throw Error(response.statusText)
        }
        return response
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(jenisConsigneeBerangkatGetSuccess(false, data))
      })
      .catch((err) => {
        console.log(err, 'err cuk')
      })
  }
}